import styled from '@emotion/styled';
import { TabletWidth } from '../../../global.style';
import { getColor } from '../../common/UICommon';

const BenefitsWrapper = styled.div`
  margin-top: 40px;
`;

const BenefitsTitle = styled.h2`
  font-family: Lora;
  font-size: 28px;
  font-weight: 600;
  line-height: 32px;
  margin-bottom: 24px;
  color: ${getColor('GRAY_80')};

  @media (max-width: ${TabletWidth}px) {
    font-size: 20px;
    line-height: 26px;
  }
`;

const BenefitsList = styled.div`
  display: inline-block;
`;

const BenefitRow = styled.div`
  text-align: left;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 8px;
`;

const Tick = styled.span`
  margin-right: 8px;
`;

const Benefit = styled.span``;

interface Props {
  benefits: string[];
}

export const PaymentCompletedtepBenefits: React.FC<Props> = ({ benefits }) => {
  return (
    <BenefitsWrapper>
      <BenefitsTitle>Enjoy Circles+ with</BenefitsTitle>
      <BenefitsList>
        {benefits.map((benefit) => (
          <BenefitRow key={benefit}>
            <Tick>✔</Tick>
            <Benefit>{benefit}</Benefit>
          </BenefitRow>
        ))}
      </BenefitsList>
    </BenefitsWrapper>
  );
};
